import { environmentService, getRequestHandler, postRequestHandler } from '@/utils/services';

const DefaultState = () => {
  return {
    apiUrl: null,
    isLogstockLoading:false,
    logstock:[],
    modules:[],
    actions:[],
    hotels:[],
    users:[],
    actionSelected:null,
    search:{
      from:null,
      to: null,
      pagination: {
        page: 1,
        per_page: 20
      },
      sort: {
        field: 'id',
        order: 'desc'
      }
    },
    total:null
  };
},

state = DefaultState(),

getters = {
  logstock: state => state.logstock,
  modules: state => state.modules,
  actions: state => {
    return state.actionSelected? state.actions.filter(action=>action.module_id==state.actionSelected): state.actions;
  },
  hotels: state => state.hotels,
  isLogstockLoading: state => state.isLogstockLoading,
  total: state => state.total,
  pagination: state => state.search.pagination,
  sort: state => state.search.sort,
  actionSelected: state => state.actionSelected
},

mutations = {
  setLogsUrls(state){
    state.apiUrl = environmentService.apiUrlLogs;
  },
  setHotelsUrls(state){
    state.apiHotelUrl = environmentService.apiUrlHotel;
  },
  setHotels(state, payload){
    state.hotels = payload;
  },
  setTotal(state, payload){
    state.total = payload;
  },
  setLogstock(state, payload){
    state.logstock = payload;
  },
  setModules(state, payload){
    state.modules = payload;
  },
  setActions(state, payload){
    state.actions = payload;
  },
  setActionSelected(state, payload){
    state.actionSelected = payload;
  },
  setPagination(state, payload){
    state.search.pagination.page = payload;
  },

  setOrder(state, payload){
    state.search.sort.field=payload.field;
    state.search.sort.order=payload.order;
  },

  setDates(state, payload){
    const today = new Date()
    let minDateSet = new Date(today.getTime());
    minDateSet.setFullYear(today.getFullYear() - 1);
    let maxDateSet = new Date(today.getTime());
    maxDateSet.setFullYear(today.getFullYear() + 1);
    if (payload.calendarData.dateRange.start.date && payload.calendarData.dateRange.end.date){
      state.search.from = new Date(payload.calendarData.dateRange.start.date).toISOString().split('T')[0];
      state.search.to = new Date(payload.calendarData.dateRange.end.date).toISOString().split('T')[0];
    }else{
      state.search.from = minDateSet.toISOString().split('T')[0];
      state.search.to = maxDateSet.toISOString().split('T')[0];
    };
  },

  setSearchIds(state, payload){
    if (payload.userId){
      state.search.userId = payload.userId;
    }else{
      delete state.search['userId'];
    };

    if (payload.moduleId){
      state.search.moduleId = payload.moduleId;
    }else{
      delete state.search['moduleId'];
    };

    if (payload.actionId){
      state.search.actionId = payload.actionId;
    }else{
      delete state.search['actionId'];
    };
    if (payload.bookingId){
      state.search.bookingId = payload.bookingId;
    }else{
      delete state.search['bookingId'];
    };
    if (payload.hotelId){
      state.search.hotelId = payload.hotelId;
    } else {
      delete state.search['hotelId'];
    };
  },

  toggleLogstockLoading(state){
    state.isLogstockLoading = !state.isLogstockLoading;
  },

  RESET_STATE(state){
    Object.assign(state, DefaultState());
  }
},

actions = {
  setLogsUrls({ commit }){
    commit('setLogsUrls');
  },
  setHotelsUrls({ commit }){
    commit('setHotelsUrls');
  },
  setActionSelected({ commit }, payload){
    commit('setActionSelected', payload);
    commit('setPagination', 1);
  },
  async getModules({ commit, state, rootState}){
    let modules = await getRequestHandler(`${state.apiUrl}/modules`, {headers: rootState.auth.headers});
    commit('setModules', modules);
  },

  async getActions({ commit, state, rootState}){
    let actions =  await getRequestHandler(`${state.apiUrl}/actions`, {headers: rootState.auth.headers});
    commit('setActions', actions);
  },

  async getHotels({ commit, state, rootState}){
    let hotels = await getRequestHandler(`${state.apiHotelUrl}/hotels`, {headers: rootState.auth.headers});
    commit('setHotels', hotels);
  },

  async findLogstock({ commit, state, rootState}, payload){
    commit('toggleLogstockLoading');
    // commit('setLogs',[]);
    if (payload){
      commit('setDates', payload.calendar);
      commit('setSearchIds', payload.fieldIds);
      commit('setPagination', payload.pagination.page);
    }
    let logstock = await postRequestHandler(`${state.apiUrl}/logstocks`, state.search , {headers: rootState.auth.headers});
    if (logstock.status==200){
      commit('setTotal', logstock.data.total);
      commit('setLogstock', logstock.data);
    } else {
      commit('setTotal', 0)
      commit('setLogstock', []);
    }
    commit('toggleLogstockLoading');
  },

  async paginateData({ commit, dispatch}, payload){
    commit('setPagination', payload);
    // await dispatch('findLogs');
  },

  async sortData({ commit, dispatch}, payload){
    commit('setOrder', payload);
    await dispatch('findLogstock');
  },

  RESET_STATE({ commit }){
    commit('RESET_STATE');
  }
};

export default {
  namespaced:true,
  state,getters,mutations,actions
};



// WEBPACK FOOTER //
// ./src/store/modules/logstock.js